// extracted by mini-css-extract-plugin
module.exports = {"link":"styles__link___1ZZct"};